// Clean this up with removal of Use_CL_New_Recording_Studio_Timeline ff
export enum TIMELINE_DISPLAY_TYPE {
  PROGRESS_BAR = 'PROGRESS_BAR',
  SPEAKERS = 'SPEAKERS',
  SEGMENTS = 'SEGMENTS',
  EXTERNAL = 'EXTERNAL'
}

export enum TRANSCRIPT_DISPLAY_TYPE {
  FULL = 'FULL'
}
